

































































































import { Component, ComponentConfig, QuestionTypeChecker, VueComponent } from "@zoovu/runner-browser-api";
import {
  AnimationsAndTransitionsConfiguration,
  PageView as PageViewBase,
  TransitionStyle,
} from "@zoovu/runner-web-design-base";
import InvisibleWrapper from "./invisible-wrapper.vue";
import { getTransitionDurationValue, getTransitionName } from "../styles/abstract/transition";

interface TransitionDuration {
  enter?: number;
  leave?: number;
}

@Component
export default class PageView extends PageViewBase {
  @ComponentConfig(AnimationsAndTransitionsConfiguration)
  animationsAndTransitionsConfiguration: AnimationsAndTransitionsConfiguration;

  transitionDuration: TransitionDuration | null = null;

  get selectedTransitionStyle(): TransitionStyle {
    return this.animationsAndTransitionsConfiguration.transitionStyle.selected;
  }

  get someQuestionIsChoiceQuestion(): boolean {
    return this.flowStep.questions.some((question) => QuestionTypeChecker.isChoiceQuestion(question));
  }

  get transitionComponent(): string | VueComponent {
    if (this.animationsAndTransitionsConfiguration.transitionsEnabled) {
      return "transition";
    }
    return InvisibleWrapper;
  }

  get transitionName(): string {
    if (this.animationsAndTransitionsConfiguration.transitionsEnabled) {
      return getTransitionName(this.selectedTransitionStyle);
    }
    return "";
  }

  setTransitionDuration(): void {
    if (this.selectedTransitionStyle === TransitionStyle.SLIDE_LEFT && this.someQuestionIsChoiceQuestion) {
      this.transitionDuration = {
        enter: 0,
        leave: getTransitionDurationValue(this.animationsAndTransitionsConfiguration.transitionSpeed.selected),
      };
    }
  }

  unsetTransitionDuration(): void {
    this.transitionDuration = null;
  }
}
